import React, { useContext, useEffect, useState } from "react";
import PageTitle from "../../components/PageTitle/PageTitle";
import {
  Box,
  Button,
  FormControl,
  Grid,
  MenuItem,
  Select,
  Typography,
  makeStyles,
  Paper,
} from "@material-ui/core";
import ApiConfig from "../../config/ApiConfig";
import { DropzoneArea } from "material-ui-dropzone";
import ArrowBackIcon from "@material-ui/icons/ArrowBack";
import Axios from "axios";
import { useHistory } from "react-router-dom/cjs/react-router-dom";
import { UserContext } from "../../context/User";
import CircularProgressWithBackdrop from "../../components/Loader/loader";
const useStyles = makeStyles({
  content: {
    padding: "50px",
    border: "1px solid black",
    background: "white",
  },
  textcontent1: {},
  textcontent: {
    width: "100%",
  },
  Image: {
    width: "100%",
    // maxWidth:"59%",
    height: "auto",
  },
  Textfield: {
    fontSize: "24px",
    fontWeight: "700",
    color: "black",
  },

  button: {
    background: "#00d4ff",
    color: "white",
    borderRadius: "10px",
    textTransform: "capitalize",
    fontWeight: "600",
    marginTop: "14px",
  },
  text: {
    fontSize: "14px",
    paddingTop: "16px",
    wordBreak: "break-all",
  },
  //   content2: {
  //     display: "flex",
  //     flexDirection: "column",
  //     alignItems: "center",
  //     gap: "10px",
  //   },
  image: {
    padding: " 10px",
    border: " 1px solid black",
    display: "flex",
    justifyContent: "center",
    width: "100%",
  },

  "@media (max-width: 960px) and (min-width: 500px)": {
    content: {
      padding: "30px",
    },
    Textfield: {
      fontSize: "20px",
    },
    button: {
      fontSize: "18px",
    },
  },
});

function TestDetails(props) {
  const ContextId = useContext(UserContext);
  const classes = useStyles();
  const history = useHistory();
  const [viewTest, setViewDetails] = useState(null);
  const [testId, setTestId] = useState(ContextId.id);
  const [result, setResult] = useState([]);
  const [tutorial, setTutorial] = useState();
  const [testIMG, setTestIMG] = useState(null);
  const [loader, setLoader] = useState(false);
  console.log(result, "resultresult");
  const viewTestDetails = async () => {
    setLoader(true);
    try {
      const res = await Axios({
        method: "GET",
        url: ApiConfig.viewTestAdmin,
        headers: {
          Authorization: `Bearer ${window.localStorage.getItem("id_token")}`,
        },
        params: {
          radomTestId: testId,
        },
      });

      if (res.data.status === 200) {
        setViewDetails(res?.data?.data?.testData);
        setResult(res?.data?.data?.expectedResults);
        setTutorial(res?.data?.data?.testData.tutorialVideo);
        setTestIMG(res?.data?.data?.testData.testResultImage);
        setLoader(false);
      }
    } catch (error) {
      setLoader(false);
      console.log(error);
    }
  };
  useEffect(() => {
    viewTestDetails();
  }, []);

  return (
    <>
      <PageTitle title="View Test Details" />
      {loader ? (
        <CircularProgressWithBackdrop />
      ) : (
        <Grid container justifyContent="center" spacing={3}>
          <Grid item xs={12} md={6}>
            <Paper elevation={3} style={{ padding: 24, marginBottom: 24 }}>
              <Typography variant="h6" gutterBottom style={{ fontWeight: 600 }}>
                Test Information
              </Typography>
              <Grid container spacing={2}>
                <Grid item xs={6}><b>Test ID :</b></Grid>
                <Grid item xs={6}>{viewTest?.randomTestId || "__"}</Grid>
                <Grid item xs={6}><b>Test Name :</b></Grid>
                <Grid item xs={6}>{viewTest?.testName || "__"}</Grid>
                <Grid item xs={6}><b>Incubation Time :</b></Grid>
                <Grid item xs={6}>{viewTest?.incubationTime || "__"} {viewTest?.data}</Grid>
                <Grid item xs={6}><b>Expiration Time :</b></Grid>
                <Grid item xs={6}>{viewTest?.expirationTime || "__"} {viewTest?.expirationData}</Grid>
              </Grid>
            </Paper>
            <Paper elevation={3} style={{ padding: 24, marginBottom: 24 }}>
              <Typography variant="h6" gutterBottom style={{ fontWeight: 600 }}>
                Tutorial Video
              </Typography>
              <Box style={{ textAlign: "center" }}>
                {tutorial ? (
                  <video controls width="100%" height="300px">
                    <source src={tutorial} type="video/mp4" />
                    Your browser does not support the video tag.
                  </video>
                ) : (
                  <Typography>Video not found</Typography>
                )}
              </Box>
            </Paper>
          </Grid>
          <Grid item xs={12} md={6}>
            <Paper elevation={3} style={{ padding: 24, marginBottom: 24 }}>
              <Typography variant="h6" gutterBottom style={{ fontWeight: 600 }}>
                Test Result
              </Typography>
              {result?.map((data, index) => (
                <Grid container spacing={2} key={index} style={{ marginBottom: 8 }}>
                  <Grid item xs={6}><b>Test Color :</b></Grid>
                  <Grid item xs={6}>{data?.colorCode || "__"}</Grid>
                  <Grid item xs={6}><b>Test Value:</b></Grid>
                  <Grid item xs={6}>{data?.resultValue || "__"}</Grid>
                </Grid>
              ))}
              <Grid container spacing={2}>
                <Grid item xs={6}><b>Test Unit:</b></Grid>
                <Grid item xs={6}>{viewTest?.unit || "__"}</Grid>
                <Grid item xs={6}><b>Test Result:</b></Grid>
                <Grid item xs={6}>{viewTest?.testResult || "__"}</Grid>
              </Grid>
            </Paper>
            <Paper elevation={3} style={{ padding: 24, marginBottom: 24 }}>
              <Typography variant="h6" gutterBottom style={{ fontWeight: 600 }}>
                Test Sample Image
              </Typography>
              <Box style={{ textAlign: "center" }}>
                {testIMG ? (
                  <img src={testIMG} alt="img" style={{ maxWidth: "100%", maxHeight: 300, borderRadius: 8, border: "1px solid #eee" }} />
                ) : (
                  <Typography>Image not found</Typography>
                )}
              </Box>
            </Paper>
          </Grid>
        </Grid>
      )}
    </>
  );
}

export default TestDetails;
